module.exports = __webpack_public_path__ + "img/chess_chesswhite3.fe2d9336.png";